/** Axis tops a percentage chart can use, smallest first. */
const PERCENT_AXIS_STEPS = [1, 2, 5, 10, 25, 50, 100];

/**
 * Top of a 0–100% chart axis: the smallest step that still leaves 20% headroom above the highest
 * reading. A VM idling under 1% then draws a readable line instead of one flat on the floor of a
 * 0–100 axis, and a busy VM still gets the full 100.
 */
export function percentAxisMax(dataMax: number): number {
  const withHeadroom = dataMax * 1.2;
  const step = PERCENT_AXIS_STEPS.find(
    (candidate) => candidate >= withHeadroom,
  );
  return step ?? 100;
}

/** A percentage as the chart tooltips show it, e.g. "0.65%". */
export function formatPercent(value: unknown): string {
  return `${Number(value).toFixed(2)}%`;
}
